import type { TemplateIdAttributes } from './meetingSignalTypes.ts';

/**
 * Fragments of the blueprint keys that identify a "meeting" template, matched
 * as case-insensitive substrings of `blueprintModuleCompleteKey`. Derived from
 * the poster's meeting-template set mapped to the real Confluence blueprint
 * keys. (The poster's "Sprint Review" has no corresponding blueprint, so it is
 * not represented.)
 */
export const MEETING_TEMPLATE_KEY_FRAGMENTS: readonly string[] = [
	'meeting-notes', // Meeting notes
	'recurring-meeting-minutes', // Weekly meeting notes
	'1-on-1-meeting', // 1-on-1 Meeting
	'daily-stand-up', // Daily stand up
	'sprint-planning-meeting', // Sprint planning meeting
	'retrospective', // Retrospective + 4 Ls Retrospective
	'project-kickoff', // Project Kickoff
	'projectplan', // Project plan
];

/**
 * Returns true when the selected template's identity looks like one of the
 * meeting templates.
 */
export const matchesMeetingTemplate = (
	template: TemplateIdAttributes | null | undefined,
): boolean => {
	const id = template?.id;
	if (!id) {
		return false;
	}
	const normalised = id.toLowerCase();
	return MEETING_TEMPLATE_KEY_FRAGMENTS.some((fragment) => normalised.includes(fragment));
};
